import React, { useEffect, useRef } from "react";

/**
 * Full-height side panel used for every secondary action in the WhatsApp inbox
 * (no small pop-up modals). Positioned absolutely inside .wa-root so it stays
 * within its Webtop window and below the RingCentral widget (Rule 7).
 * Esc closes the panel.
 */
const SidePanel = ({ title, subtitle, onClose, footer, wide = false, children, initialFocusRef }) => {
  const panelRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose?.();
      }
    };
    const node = panelRef.current;
    node?.addEventListener("keydown", onKey);
    // Focus the first useful control so keyboard users can start immediately.
    const target = initialFocusRef?.current || node?.querySelector("input, textarea, select, button:not([data-wa-close])");
    target?.focus?.();
    return () => node?.removeEventListener("keydown", onKey);
  }, [onClose, initialFocusRef]);

  return (
    <>
      <div className="wa-panel-backdrop" onClick={onClose} aria-hidden="true" />
      <aside ref={panelRef} className={`wa-panel ${wide ? "wa-panel--wide" : ""}`} role="dialog" aria-modal="true" aria-label={title} tabIndex={-1}>
        <header className="wa-panel__head">
          <div style={{ flex: "1 1 auto", minWidth: 0 }}>
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button type="button" className="wa-icon-btn" onClick={onClose} aria-label="Close panel" title="Close (Esc)" data-wa-close>
            <i className="fa-solid fa-xmark" />
          </button>
        </header>
        <div className="wa-panel__body">{children}</div>
        {footer && <footer className="wa-panel__foot">{footer}</footer>}
      </aside>
    </>
  );
};

export default SidePanel;
